export default "__VITE_ASSET__CO$HdLqM__"